var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-group', {
    staticClass: "attachment-input",
    attrs: {
      "label": _vm.label,
      "errors": _vm.internalErrors
    },
    on: {
      "focus": _vm.focus
    }
  }, [_c('attachment-picker', {
    ref: "picker",
    attrs: {
      "attachment-type": _vm.attachmentType,
      "multiple": false
    },
    on: {
      "select": _vm.selectAttachment
    }
  }), _vm._v(" "), (_vm.internalValue) ? _c('div', {
    staticClass: "attachment-input__preview uk-margin-small-bottom"
  }, [(_vm.internalValue.thumbImageUrl) ? _c('thumbnail', {
    staticClass: "uk-margin-small-bottom",
    attrs: {
      "attachment": _vm.internalValue
    }
  }) : _c('a', {
    attrs: {
      "href": _vm.internalValue.url
    }
  }, [_vm._v("\n      " + _vm._s(_vm.internalValue.name || _vm.internalValue.url) + "\n    ")])], 1) : _vm._e(), _vm._v(" "), _c('file-upload-button', {
    ref: "uploadButton",
    attrs: {
      "attachment-type": _vm.attachmentType,
      "disabled": _vm.disabled
    },
    on: {
      "upload": _vm.selectUploadedAttachment
    }
  }), _vm._v(" "), _c('common-button', {
    attrs: {
      "icon": "album",
      "text": _vm.$t('actions.select'),
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        _vm.$refs.picker.show()
      }
    }
  }), _vm._v(" "), (_vm.internalValue) ? _c('common-button', {
    attrs: {
      "icon": "close",
      "text": _vm.$t('actions.remove'),
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.removeAttachment
    }
  }) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3effae88","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/AttachmentInput.vue
// module id = 1948
// module chunks = 0